<template>
  <div class="contNews_box">
    <div v-for="(item, index) in list" :key="index">
      <a v-if="item.urlAddress && item.urlAddress!=''" :href="item.urlAddress" tag="div"
      class="contNews_title">
      <div
        class="contentImg"
        v-show="
          item.picUrl == null || item.picUrl == ''
            ? (isImg = false)
            : (isImg = true)
        "
      >
        <img :src="item.picUrl" alt />
      </div>
      <div>
        <div>{{ item.newsTitle }}</div>
        <div>{{ item.sNewsTitle }}</div>
        <div>{{ item.startTime }}</div>
      </div>
      </a>
<router-link v-else
      :to="{
        path: '/scNewsDetail',
        query: {
          newsId: item.newsId,
          source: item.source,
          createBy: item.createBy,
          newsTitle: item.newsTitle,
        },
      }"
      tag="div"
      class="contNews_title"
      
    >
      <div
        class="contentImg"
        v-show="
          item.picUrl == null || item.picUrl == ''
            ? (isImg = false)
            : (isImg = true)
        "
      >
        <img :src="item.picUrl" alt />
      </div>
      <div>
        <div>{{ item.newsTitle }}</div>
        <div>{{ item.sNewsTitle }}</div>
        <div>{{ item.startTime }}</div>
      </div>
    </router-link>
    </div>
    
    <router-link
      :to="{
        path: '/newsDetail',
        query: { classId: classId, classCName: classCName },
      }"
      tag="div"
      class="more"
    >
      更多
      <img src="../../../static/img/index/moreNews.png" alt />
    </router-link>
  </div>
</template>
<script>
import { postNewsByPage, getScList } from "../../api/api";
export default {
  data() {
    return {
      list: [],
      isImg: false,
      classId: null,
      classCName: "",
    };
  },
  created() {
    getScList().then((res) => {
      // //console.log(res);
      this.classId = res[0].classId;
      this.classCName = res[0].classCName;
    });
    postNewsByPage(14950394867382, 1, 4).then((res) => {
      // //console.log(res);
      this.list = res.list;
    });
  },
};
</script>
<style scoped>
.contNews_box {
  padding-left: 2%;
  width: 51%;
  position: relative;
}
.contNews_title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3%;
  background-color: #f8f8fa;
  color: #333;
  height: 100px;
  width: 100%;
  padding: 10px 12px;
  padding-left: 0;
}
.contNews_title > div:nth-of-type(1) {
  width: 22%;
  height: 75px;
  text-align: center;
  padding-left: 2%;
}
.contNews_title > div:nth-of-type(2) {
  width: 78%;
  padding: 5px;
  padding-left: 15px;
}
.contNews_title > div:nth-of-type(1) > div:nth-of-type(1) {
  font-size: 22px;
  color: #69686b;
  font-weight: bold;
}
.contNews_title > div:nth-of-type(1) > div:nth-of-type(2) {
  font-size: 12px;
  color: #c5c5c7;
}
.contNews_title > div:nth-of-type(2) > div:nth-of-type(1) {
  width: 88%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.contNews_title > div:nth-of-type(2) > div:nth-of-type(2) {
  width: 95%;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  -webkit-line-clamp: 2;
    line-clamp: 2;
        -webkit-box-orient: vertical;
  color: #c5c5c7;
  font-size: 12px;
  margin-top: 5px;
}
.contNews_title > div > div {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.contNews_title:hover {
  color: white;
  background: #006cab;
  cursor: pointer;
}
.more {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: #f8f8fa;
  width: 120px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
}
.contentImg > img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/indexComp/contentNews.vue